import { Layout, Row, Col } from "antd";

function Footer() {
  const { Footer: AntFooter } = Layout;

  return (
    <AntFooter style={{ background: "#fafafa" }}>
      <Row className="just">
        <Col xs={24} md={12} lg={12}>
          <div className="copyright">
            © 2022,
            <a
              href="https://www.engidatravel.com/"
              className="font-weight-bold"
            >
              Engida Travel Technology
            </a>
          </div>
        </Col>
        <Col xs={24} md={12} lg={12}>
          <div className="footer-menu">
            <ul>
              <li className="nav-item">
                <a
                  href="https://www.engidatravel.com/"
                  className="font-weight-bold"
                >
                  Endida Travel
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="https://www.engidatravel.com/contact-us"
                  className="nav-link text-muted"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </Col>
      </Row>
    </AntFooter>
  );
}

export default Footer;
